const dataFlowColors = {
  // 充電設備穩定度
  ChargingEquipmentUtilization: '#c891ff',
  ChargingEquipmentHealthRate: '#81d4a9',
  ChargingEfficiency: '#417ffa',
  ChargingEquipmentServiceStatusRate: '#fcd177',
  // 能源調度安全性
  ContractCapacityEnergyPower: '#c891ff',
  DistributionBoardCurrentUsageRate: '#417ffa',
  ChargingPileEnergyStartRate: '#81d4a9',
  EnergyConsumptionTrend: '#fcd177',
  CarbonEmissionTrend: '#808080',
  // 財務獲利效率度
  FinancialProfit: '#c891ff',
  OperationalPerformanceFunnel: '#f29500',
  ChargingOrderYieldRateTrend: '#417ffa',
  ChargingStationEfficiency: '#81d4a9',
  ChargingStationTurnoverRate: '#fcd177',
};

export default dataFlowColors;
